// F3 debug overlay (UI-4): fps, position, chunk, facing, sky/block light, game
// mode, loaded-chunk count, worst frame ms. Toggled with F3. Client-only (ENG-1).
// Biome/heap/entity-count fields fill in at their milestones (M5/M8/M24).
import { h } from '../h';
import { WORLD } from '../../../sim/config';
import type { Game } from '../../boot';

const floorDiv = (a: number, b: number): number => Math.floor(a / b);

export class F3 {
  readonly el: HTMLElement;
  private visible = false;

  constructor() {
    this.el = h('div', { class: 'bb-f3' });
    this.el.style.display = 'none';
    document.addEventListener('keydown', (e) => {
      if (e.code === 'F3') { e.preventDefault(); this.visible = !this.visible; this.el.style.display = this.visible ? 'block' : 'none'; }
    });
  }

  update(game: Game): void {
    if (!this.visible) return;
    const b = game.player.body;
    const x = Math.floor(b.x), y = Math.floor(b.y), z = Math.floor(b.z);
    const cx = floorDiv(x, WORLD.SECTION), cz = floorDiv(z, WORLD.SECTION);
    const sky = game.world.getSkyLight(x, y, z);
    const blk = game.world.getBlockLight(x, y, z);
    const yawDeg = ((-game.player.yaw * 180) / Math.PI).toFixed(0);
    this.el.textContent = [
      `TerraForge — ${game.fps} fps`,
      `xyz ${b.x.toFixed(2)} ${b.y.toFixed(2)} ${b.z.toFixed(2)}`,
      `block ${x} ${y} ${z}  chunk ${cx} ${cz}`,
      `facing ${yawDeg}°  light sky ${sky} block ${blk}`,
      `dim ${game.world.dimension}  mode ${game.playerState.gameMode}  chunks ${game.world.loadedCount}`,
      `worst frame ${game.worstFrameMs.toFixed(1)} ms`,
    ].join('\n');
  }
}
